<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<a id="page_2"></a>
<a id="page_3"></a>
<h1 class="title">I Am From Brownsville</h1>
<p class="author">Arthur Granit</p>
<div class="img_container">
<img alt="images" src="images/PhilosophicalLibrary-Sw_fmt.jpg"/>
</div>
<div class="img_container">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2e4bba27